
export class CompanyPoliticsFinancialTransformer {

  static errorsTransformer() {
    return (errors: Record<string, string[]>) => {
      return Object.entries(errors).map(([key, value]) => {
        if (key.endsWith('.base')) {
          key = '_base';
        }

        if (key.endsWith('.fee_rule_id')) {
          key = '_base';
        }

        return {
          [key]: value.join(', ')
        }
      });
    };
  }

}
